import React from 'react'
import Card from './homeCard'
import Cardss from './homeCards'

import EXPERTISE from '../../static/data/expertise'

const Expertise = () => {
  const loadCards = EXPERTISE.map((domain, index) => {
    return <Card {...domain} />
  })

  return (
    <div className='section home-expertise'>
      <div
        className='section home-expertise-intro'
        data-aos='fade-up'
        data-aos-delay='500'
      >
        <div className='heading'> Our Expertise</div>
        <p className='sub-heading'>We know to Manage Water</p>
      </div>
      <div className='home-expertise-card-container'>
        <Cardss />
      </div>
    </div>
  )
}

export default Expertise
